// extracted by mini-css-extract-plugin
export default {"img-icon":"PropertyTypeOption_img-icon__ZU-EE"};